import { __classPrivateFieldGet, __classPrivateFieldSet } from 'tslib';
import { createSingletonMixin } from '@descope/sdk-helpers';

const initLifecycleMixin = createSingletonMixin((superclass) => { var _InitLifecycleMixinClass_isInit, _a; return _a = class InitLifecycleMixinClass extends superclass {
        constructor() {
            super(...arguments);
            _InitLifecycleMixinClass_isInit.set(this, true);
        }
        connectedCallback() {
            var _b, _c;
            (_b = super.connectedCallback) === null || _b === void 0 ? void 0 : _b.call(this);
            if ((_c = this.shadowRoot) === null || _c === void 0 ? void 0 : _c.isConnected) {
                // the init function is running once, on the first time the component is connected
                if (__classPrivateFieldGet(this, _InitLifecycleMixinClass_isInit, "f")) {
                    __classPrivateFieldSet(this, _InitLifecycleMixinClass_isInit, false, "f");
                    this.init();
                }
            }
        }
        // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-empty-function
        async init() { }
    },
    _InitLifecycleMixinClass_isInit = new WeakMap(),
    _a; });

export { initLifecycleMixin };
//# sourceMappingURL=initLifecycleMixin.js.map
